import { render, staticRenderFns } from "./robot-select.vue?vue&type=template&id=10465822&scoped=true&"
import script from "./robot-select.vue?vue&type=script&lang=js&"
export * from "./robot-select.vue?vue&type=script&lang=js&"
import style0 from "./robot-select.vue?vue&type=style&index=0&id=10465822&prod&scoped=true&lang=less&"
import style1 from "./robot-select.vue?vue&type=style&index=1&id=10465822&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10465822",
  null
  
)

export default component.exports